import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Row, Col, Card, Table } from "react-bootstrap";
import ClickBack from "../../components/buttons/ClickBack";
import { diagnostiquerSiret } from "../../utilities";



import moment from "moment";
import { GetOneUser, GetUserOrders } from "./dataService";
import LogoClientCard from "./LogoClientCard";
import PaniersAbandonnes from "./PaniersAbandonnes";

function ShowScreen(props) {
  const [userData, setUserData] = useState(null);
  const [userOrders, setUserOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const { id } = useParams();


  const fetchUserData = async (id) => {
    try {
      const user = await GetOneUser(id);
      setUserData(user);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchUserOrders = async (id) => {
    try {
      setLoadingOrders(true);
      const orders = await GetUserOrders(id);
      // Trier les commandes de la plus récente à la plus ancienne
      const sortedOrders = orders.sort((a, b) => {
        return new Date(b.DateCommande) - new Date(a.DateCommande);
      });
      setUserOrders(sortedOrders);
    } catch (error) {
      console.error("Error fetching user orders:", error);
      setUserOrders([]);
    } finally {
      setLoadingOrders(false);
    }
  };

  useEffect(() => {
    fetchUserData(id);
    fetchUserOrders(id);
  }, [id]);

  // Fonction pour définir les status commande fournisseur
  const mapStatusCommande = (statusID) => {
    switch (statusID) {
      case 1:
        return "En cours de livraison";
      case 2:
        return "Livré";
      case 3:
        return "En cours de préparation";
      case 4:
        return "En cours de validation";
      case 5:
        return "Validé";
      case 6:
        return "Annulé";
      default:
        return "";
    }
  };

  if (!userData) {
    return (
      <Container>
        <p>Loading...</p>
      </Container>
    );
  }
  const defaultAddress = userData.user_adresses?.find(
    (addr) => addr.default === 1
  );
  return (
    <Container>
      <div className="userList">
        <p className="h6">
          Home / Users / {userData.nom} {userData.prenom}
        </p>

        <Row className="pt-4 pb-2">
          <Col style={{ display: "flex", alignItems: "center" }}>
            <ClickBack editPage={true} />
            <h1 className="p-1">
              {userData.nom} {userData.prenom}
            </h1>
          </Col>
        </Row>

        <Card className="mb-3">
          <Card.Body>
            <Card.Title className="pb-3">Détail profil Utilisateur</Card.Title>
            <Col className="pb-3">
              <p>
                <strong>Date de création: </strong>
                {moment(userData.created_at).format("DD/MM/YYYY , HH:MM")}
              </p>
            </Col>
            <Row className="pb-3">
              <Col>
                <p>
                  <strong>ID: </strong>
                  {userData.id}
                </p>
              </Col>

              <Col>
                <p>
                  <strong>Etat: </strong>
                  {userData.status === 1 ? "Active" : "Inactive"}
                </p>
              </Col>

              <Col>
                <p>
                  <strong>Paiement en compte: </strong>
                  {userData.paiement_en_compte ? "Autorisé" : "Non autorisé"}
                </p>
              </Col>
              {userData.paiement_en_compte && (
                <Col>
                  <p>
                    <strong>Email comptable: </strong>
                    {userData.email_comptable || "—"}
                  </p>
                </Col>
              )}
              {userData.paiement_en_compte && (
                <Col>
                  <p>
                    <strong>Relances de facture: </strong>
                    {userData.exclu_relance_facture ? "Exclu" : "Actives"}
                  </p>
                </Col>
              )}
              {userData.role === 2 && (
                <Col>
                  <p>
                    <strong>Facturation électronique: </strong>
                    {userData.facturation_electronique ? (
                      <span className="text-success">
                        Activée
                        {userData.facturation_electronique_activee_le &&
                          ` le ${moment(
                            userData.facturation_electronique_activee_le
                          ).format("DD/MM/YYYY")}`}
                      </span>
                    ) : (
                      "Non activée"
                    )}
                  </p>
                </Col>
              )}
            </Row>
            <Row className="pb-3">
              <Col>
                <p>
                  <strong>Prénom: </strong>
                  {userData.prenom}
                </p>
              </Col>
              <Col>
                <p>
                  <strong>Nom: </strong>
                  {userData.nom}
                </p>
              </Col>
            </Row>
            <Row className="pb-3">
              <Col>
                <p>
                  <strong>Numéro de téléphone: </strong>
                  {userData.user_profil?.telephone || "-"}
                </p>
              </Col>
              <Col>
                <p>
                  <strong>Email: </strong>
                  {userData.email}
                </p>
              </Col>
            </Row>

            <Row className="pb-3">
              <Col>
                <p>
                  <strong>Nom de l'adresse: </strong>
                  {userData.user_adresses?.[0]?.name || "-"}
                </p>
              </Col>
              <Col>
                <p>
                  <strong>Adresse: </strong>
                  {userData.user_adresses?.[0]?.adresse || "-"}
                </p>
              </Col>
            </Row>
            <Row className="pb-3">
              {userData.role === 2 && (
                <>
                  <Row className="pb-3">
                    {userData.user_profil?.siret && (
                      <Col>
                        <p>
                          <strong>Numéro de SIRET: </strong>
                          {userData.user_profil.siret}
                          {/* Signale d'un coup d'œil les comptes à compléter avant
                              la bascule en facturation électronique. */}
                          {(() => {
                            const d = diagnostiquerSiret(userData.user_profil.siret);
                            if (d.etat === "valide") return null;
                            return (
                              <span className="text-warning ms-2" title={d.message}>
                                ⚠ {d.etat === "incomplet" ? "SIREN seul" : "invalide"}
                              </span>
                            );
                          })()}
                        </p>
                      </Col>
                    )}
                    {userData.user_profil?.tva && (
                      <Col>
                        <p>
                          <strong>Numéro de TVA: </strong>
                          {userData.user_profil.tva}
                        </p>
                      </Col>
                    )}
                  </Row>
                  <Row className="pb-3">
                    {userData.user_profil?.societe && (
                      <Col>
                        <p>
                          <strong>Société: </strong>
                          {userData.user_profil.societe}
                        </p>
                      </Col>
                    )}
                  </Row>
                </>
              )}
              <Col>
                {userData.commentaire && (
                  <p>
                    <strong>Commentaire: </strong>
                    {userData.commentaire}
                  </p>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Logo de l'espace client : entreprises seulement. L'aperçu vient de
            `logo_client_url`, que seul cet écran reçoit — il montre le logo
            stocké même quand le client ne le voit pas encore. */}
        {userData.role === 2 && (
          <LogoClientCard
            userId={userData.id}
            urlInitiale={userData.logo_client_url}
            enCompte={!!userData.paiement_en_compte}
          />
        )}

        {/* Liste des commandes de l'utilisateur */}
        <Card className="mb-3">
          <Card.Body>
            <Card.Title className="pb-3">
              Historique des commandes ({userOrders.length})
            </Card.Title>
            {loadingOrders ? (
              <p>Chargement des commandes...</p>
            ) : userOrders.length === 0 ? (
              <p>Aucune commande trouvée pour cet utilisateur.</p>
            ) : (
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>N° Commande</th>
                    <th>Date commande</th>
                    <th>Date et Heure de livraison</th>
                    <th>Adresse pick-up</th>
                    <th>Adresse de livraison</th>
                    <th>Tarif liv</th>
                    <th>Nom du Livreur</th>
                    <th>Montant livraison</th>
                    <th>Statut</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {userOrders.map((order) => (
                    <tr key={order.id}>
                      <td>{order.id}</td>
                      <td>
                        {order.DateCommande
                          ? moment(order.DateCommande).format("DD/MM/YYYY HH:mm")
                          : "-"}
                      </td>
                      <td>
                        {order.DateLivraison
                          ? moment(order.DateLivraison).format("DD/MM/YYYY HH:mm")
                          : "-"}
                      </td>
                      <td>{order.AdressePickUp || "-"}</td>
                      <td>{order.AdresseLivraison || "-"}</td>
                      <td>{order.livraisonHT ? `${order.livraisonHT} €` : "-"}</td>
                      <td>
                        {order.livreur_profil
                          ? `${order.livreur_profil.nom || ""} ${order.livreur_profil.prenom || ""}`.trim()
                          : "-"}
                      </td>
                      <td>{order.MontantCommande ? `${order.MontantCommande} €` : "-"}</td>
                      <td>{mapStatusCommande(order.StatuCommande)}</td>
                      <td>
                        <Link
                          to={`/livraisons/show/${order.id}`}
                          className="btn btn-sm btn-primary"
                        >
                          Voir détails
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>

        {/* Formulaires commencés jamais validés, juste après les commandes : on
            voit d'un coup d'œil s'il a fini par commander. */}
        <PaniersAbandonnes idClient={id} commandes={userOrders} />

        {/* Additional sections or details can be added here */}
      </div>
    </Container>
  );
}

export default ShowScreen;
